import * as types from '../constants/actionTypes';

const initialState = {
  firmNames: [],
  activeFirmNames: [],
  editingFirmName: null,
  loading: false,
  creating: false,
  updating: false,
  error: null,
  totalCount: 0
};

const firmNameReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch all firm names
    case types.FETCH_FIRM_NAMES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case types.FETCH_FIRM_NAMES_SUCCESS:
      return {
        ...state,
        loading: false,
        firmNames: action.payload.data || [],
        totalCount: action.payload.total || 0,
        error: null
      };
    case types.FETCH_FIRM_NAMES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Fetch active firm names
    case types.FETCH_ACTIVE_FIRM_NAMES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case types.FETCH_ACTIVE_FIRM_NAMES_SUCCESS:
      return {
        ...state,
        loading: false,
        activeFirmNames: action.payload.data || [],
        error: null
      };
    case types.FETCH_ACTIVE_FIRM_NAMES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Get single firm name
    case types.GET_FIRM_NAME_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case types.GET_FIRM_NAME_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null
      };
    case types.GET_FIRM_NAME_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Create firm name
    case types.CREATE_FIRM_NAME_REQUEST:
      return {
        ...state,
        creating: true,
        error: null
      };
    case types.CREATE_FIRM_NAME_SUCCESS:
      return {
        ...state,
        creating: false,
        firmNames: [action.payload.data, ...state.firmNames],
        totalCount: state.totalCount + 1,
        error: null
      };
    case types.CREATE_FIRM_NAME_FAILURE:
      return {
        ...state,
        creating: false,
        error: action.payload
      };

    // Update firm name
    case types.UPDATE_FIRM_NAME_REQUEST:
      return {
        ...state,
        updating: true,
        error: null
      };
    case types.UPDATE_FIRM_NAME_SUCCESS:
      return {
        ...state,
        updating: false,
        firmNames: state.firmNames.map(firm =>
          firm.id === action.payload.data.id ? action.payload.data : firm
        ),
        editingFirmName: null,
        error: null
      };
    case types.UPDATE_FIRM_NAME_FAILURE:
      return {
        ...state,
        updating: false,
        error: action.payload
      };

    // Set editing firm name
    case types.SET_FIRM_NAME_EDITING:
      return {
        ...state,
        editingFirmName: action.payload
      };

    // Clear editing firm name
    case types.CLEAR_FIRM_NAME_EDITING:
      return {
        ...state,
        editingFirmName: null
      };

    default:
      return state;
  }
};

export default firmNameReducer;
